import React from 'react';
import ReactDOM from 'react-dom';
import Product from '../react/Product.jsx';
import Axios from 'axios';
import AsyncView from '../components/AsyncView';
import trackEvent from '../utils/trackEvent';
import loadjs from 'loadjs';

export default class StaticProductReact {
  constructor(section) {
    this.context = JSON.parse(document.querySelector('[data-product-context]').innerHTML);
    this.context.loadWair = this.loadWair;
    this.root = section.el.querySelector('[data-section-root]');
    this.pbc = document.querySelector('.page-body-content');
    this.loadWair = this.loadWair.bind(this);
    this.loadProduct = this.loadProduct.bind(this);
    this.renderProduct = this.renderProduct.bind(this);
    this.locale = window.Shopify.locale && window.Shopify.locale !== 'en' ? `/${window.Shopify.locale}` : '';


    this.url = new URL(window.location);
    let variantId = this.url.searchParams.get('variant');
    this.wairLoaded = false;
    let defaultVariant = null; 
    if (variantId) {
      variantId = parseInt(variantId, 10);
      defaultVariant = section.data.product.variants.find(v => v.id === variantId);
    } else if (section.data.product.variants && section.data.product.variants.length === 1) {
      defaultVariant = section.data.product.variants[0];
    }
    this.settings = section.data.settings;

    this.mql = window.matchMedia('(max-width: 719px)');

    this.renderProduct(section.data, defaultVariant);
    window.dispatchEvent(new CustomEvent('localizeContent'));

    if (typeof window.twq === 'function') {
      window.twq('event', 'tw-o41kc-odvcy', {
        contents: [
          {
            content_name: section.data.product.title,
            content_id: section.data.product.id,
            content_type: section.data.product.type,
            content_price: section.data.product.price / 100,
            currency: 'USD'
          }
        ]
      });
    }

    this.scrollOnColorChangeExperience = window.customExperiences && window.customExperiences.scrollOnColorChange;

    window.addEventListener('MonetateUpdated', () => {
      this.scrollOnColorChangeExperience = window.customExperiences && window.customExperiences.scrollOnColorChange;
    });
  }

  getCurrentLanguage(handle) {
    if (window.location.pathname === `/products/${handle}` || window.location.pathname === `/products/${handle}/`) {
      return 'en'
    } else {
      return null
    }
  }

  async getProductDataEn(handle) {
    const API_URL = 'https://the-boot-company.myshopify.com/api/2025-07/graphql.json';
    const TOKEN = 'd97a827b167ebe1f72196771376e4b6d';
    const query = `
    {
      product(handle: "${handle}") {
        id
        title
        handle
        descriptionHtml
        vendor
        productType
        tags
        availableForSale
        options {
          name
          values
        }
        variants(first: 50) {
          edges {
            node {
              id
              title
              sku
              availableForSale
              selectedOptions {
                name
                value
              }
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
            }
          }
        }
        images(first: 1) {
          edges {
            node {
              src
            }
          }
        }
        media(first: 20) {
          edges {
            node {
              ... on MediaImage {
                mediaContentType
                alt
                image {
                  src
                  width
                  height
                }
              }
              ... on Video {
                mediaContentType
                sources {
                  mimeType
                  url
                  format
                  height
                  width
                }
              }
            }
          }
        }
      }
    }
    `;
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': TOKEN,
        'Accept-Language': 'en'
      },
      body: JSON.stringify({ query })
    });
    const data = await response.json();
    if (data.errors) {
      return null;
    }
    const p = data.data.product;
     if(p) { 
    const productObj = {
      id: p.id.replace('gid://shopify/Product/', ''),
      title: p.title,
      handle: p.handle,
      description: p.descriptionHtml,
      vendor: p.vendor,
      type: p.productType,
      tags: p.tags,
      available: p.availableForSale,
      options: p.options.map(o => o.name),
      options_with_values: p.options.map(o => ({
        name: o.name,
        values: o.values
      })),
      variants: p.variants.edges.map(v => ({
        id: v.node.id.replace('gid://shopify/ProductVariant/', ''),
        title: v.node.title,
        option1: v.node.selectedOptions[0]?.value || null,
        option2: v.node.selectedOptions[1]?.value || null,
        option3: v.node.selectedOptions[2]?.value || null,
        sku: v.node.sku,
        available: v.node.availableForSale,
        price: v.node.price,
        compare_at_price: v.node.compareAtPrice,
      })),
      featured_image: p.images.edges[0]?.node.src || null,
      media: p.media.edges.map(m => {
        if (m.node.mediaContentType === 'IMAGE') {
          return {
            media_type: 'image',
            src: m.node.image.src,
            width: m.node.image.width,
            height: m.node.image.height,
            alt: m.node.alt
          };
        }
        if (m.node.mediaContentType === 'VIDEO') {
          return {
            media_type: 'video',
            sources: m.node.sources
          };
        }
        return {};
      })
       };
       return productObj;
     } else {
      return null;
  }
   
  }

  loadWair() {
    if (this.wairLoaded) {
      return;
    }
    this.wairLoaded = true;
    loadjs('https://predict-v4.getwair.com/default/predict.js');
  }   

  loadProduct(product, prevVariant) {
    this.pbc.classList.add('loading');

    const productData = AsyncView.load(`${this.locale}/products/${product.handle}`, 'json').then(response => {
      const temp = document.createElement('div');
      temp.innerHTML = response.html;
      const productData = JSON.parse(temp.querySelector('[data-section-data]').innerHTML);
      this.url.pathname = `${this.locale}/products/${productData.product.handle}`;
      let defaultVariant = null;
      if (prevVariant) {
        let variantTitle = prevVariant.title.replace(/standard\s*\/\s*/i, '');
        const firstVariant = productData.product.variants.find(v => v.title.replace(/standard\s*\/\s*/i, '') === variantTitle);
        if (firstVariant) {
          defaultVariant = firstVariant;
        } else if (prevVariant.option1.startsWith('Wide') || prevVariant.option1.startsWith('Narrow')) {
          variantTitle = prevVariant.title.replace(/ \(\w+\)/i, '');
          defaultVariant = productData.product.variants.find(v => v.title.replace(/ \(\w+\)/i, '') === variantTitle);
        }
        defaultVariant && this.url.searchParams.set('variant', defaultVariant.id);
      }
      window.customExperiences = {};
      window.history.replaceState(productData, productData.product.title, this.url.href);
      this.renderProduct(productData, defaultVariant);
      this.pbc.classList.remove('loading');
      document.querySelector('title').innerHTML = response.options.page_title;
      document.querySelector('link[rel="canonical"]').href = response.options.canonical_url;

      let curVariant = defaultVariant || productData.product.variants[0];

      window.dispatchEvent(new CustomEvent('localizeContent'));

      if (this.mql.matches && (this.settings.scrollOnColorChange || this.scrollOnColorChangeExperience)) {
        if (this.root.querySelector('.product-images') && document.querySelector('.section-header')) {
          window.scrollBy({ top: this.root.querySelector('.product-images').getBoundingClientRect().top - document.querySelector('.section-header').offsetHeight, behavior: 'smooth' });
        }
      }
      /* if (typeof ga === 'function') {
        ga('set', { "page": location.pathname, "title": document.title });
        ga('send', 'pageview');
        ga('send', 'event', 'Product', 'Viewed Product', { nonInteraction: true })

        ga('send', 'event', productData.product.type, 'Viewed Product', { nonInteraction: true })
        dataLayer.push({ 'event': 'optimize.activate' });

        ga('ec:addProduct', {
          'id': curVariant.id,
          'name': curVariant.name,
          'category': productData.product.type,
          'brand': productData.product.vendor
        });
        ga('ec:setAction', 'detail');
      } */

      if (typeof fbq === 'function') {
        fbq('track', 'ViewContent', {
          content_name: curVariant.name,
          content_category: productData.product.type,
          content_ids: [productData.product.id],
          content_type: 'product_group',
          value: curVariant.price / 100,
          currency: 'USD'
        });
      }

      if (typeof window.twq === 'function') {
        window.twq('event', 'tw-o41kc-odvcy', {
          contents: [
            {
              content_name: productData.product.title,
              content_id: productData.product.id,
              content_type: productData.product.type,
              content_price: productData.product.price / 100,
              currency: 'USD'
            }
          ]
        });
      }
    });

    const promisesArray = [];
    promisesArray.push(productData);

    if (document.querySelector('#shopify-section-static-exit-intent')) {
      const exitPopup = Axios.get(`${this.locale}/products/${product.handle}?section_id=static-exit-intent`).then(response => {
        document.querySelector('#shopify-section-static-exit-intent').innerHTML = response.data;
      });
      promisesArray.push(exitPopup);
    }

    const productFeatures = Axios.get(`${this.locale}/products/${product.handle}?section_id=product-features`).then(response => {
      document.querySelector('#shopify-section-product-features').innerHTML = response.data;
    });
    promisesArray.push(productFeatures);

    Promise.all(promisesArray).then(() => {
      document.dispatchEvent(new CustomEvent("product-change"));
    });
  }

  async renderProduct(productData, defaultVariant) {
    const currentLanguage = this.getCurrentLanguage(productData.product.handle);

    const productOptionsWithValues = [];
    delete productData.product.content;
    delete productData.product.created_at;
    delete productData.product.images;
    delete productData.product.published_at;

    productData.product.options.forEach(option => {
      productOptionsWithValues.push({ name: option, values: [] });
    });

    productData.product.variants.forEach(variant => {
      variant.options.forEach((option, i) => {
        if (!productOptionsWithValues[i].values.includes(option)) {
          productOptionsWithValues[i].values.push(option);
        }
      });
    });

    productData.product.options_with_values = productOptionsWithValues;

    if (currentLanguage !== 'en') {
      const englishProduct = await this.getProductDataEn(productData.product.handle);
      
      productData.product.en = englishProduct ? englishProduct : { ...productData.product };
    } else { 
      productData.product.en = { ...productData.product };
    }

    ReactDOM.unmountComponentAtNode(this.root);
    ReactDOM.render(<Product {...productData} defaultVariant={defaultVariant} url={this.url} onProductChange={this.loadProduct} context={this.context} />, this.root);
    
     
    function waitForHeap({ timeout = 10000, interval = 50 } = {}) {
      return new Promise((resolve) => {
        // already ready?
        if (window.heap && typeof window.heap.track === 'function') return resolve(true);
    
        const start = Date.now();
        const iv = setInterval(() => {
          const ready = window.heap && typeof window.heap.track === 'function';
          const expired = Date.now() - start >= timeout;
    
          if (ready || expired) {
            clearInterval(iv);
            resolve(ready); // true if Heap ready, false if we timed out
          }
        }, interval);
      });
    }

    waitForHeap().then(() => {
     
    trackEvent('ProductView', { title: productData.product.title, vendor: productData.product.vendor, price: productData.product.price, handle: productData.product.handle });
    trackEvent('view_item', {
      currency: 'USD',
      value: productData.product.price / 100,
      items: [
        {
          item_id: productData.product.handle,
          item_name: productData.product.title,
          price: defaultVariant ? defaultVariant.price / 100 : productData.product.price / 100,
          currency: 'USD',
          item_brand: productData.product.vendor,
          item_category: productData.product.type,
          item_variant: defaultVariant ? defaultVariant.title : '',
          quantity: 1
        }
      ]
    });
    });
   

    const monetateCSS = document.querySelector('style#mt-css');
    if (monetateCSS) {
      monetateCSS.remove();
    }

    window.monetateQ = window.monetateQ || [];
    window.monetateQ.push([
      "setPageType", "product"
    ]);
    window.monetateQ.push(["addProductDetails", [productData.product.id]]);

    window.monetateQ.push([
      "trackData"
    ]);
  }

  onSectionUnload() {
    ReactDOM.unmountComponentAtNode(this.root);
  }
}
